/**
 * pano-reveal.js — DISABLED.
 * Scroll-reveal animations were causing user-perceived sluggishness.
 * As of 2026-05-14, all Pano sections render visible immediately on page load.
 *
 * If any HTML element still has the .pano-reveal class hardcoded somewhere,
 * mark it visible right away so it doesn't stay hidden.
 */
(function () {
  'use strict';
  function reveal() {
    document.querySelectorAll('.pano-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
